import React, { createContext, useCallback, useEffect, useRef, useState } from "react";

const SnackbarContext = createContext();

export default SnackbarContext;

export function SnackbarProvider({ children }) {
    const [msg, setMsg] = useState("");
    const [title, setTitle] = useState("");
    const [isDisplayed, setIsDisplayed] = useState(false);
    const [isSuccess, setIsSuccess] = useState(true);
    const timerRef = useRef(null);

    const onClose = useCallback(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        setIsDisplayed(false);
    }, []);

    const setSnackbar = useCallback((next) => {
        setTitle(next?.title ?? "");
        setMsg(next?.content ?? "");
        setIsSuccess(next?.success ?? true);
        setIsDisplayed(true);

        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            setIsDisplayed(false);
            timerRef.current = null;
        }, 5000);
    }, []);

    useEffect(() => () => {
        if (timerRef.current) clearTimeout(timerRef.current);
    }, []);

    const contextData = {
        msg,
        title,
        isDisplayed,
        isSuccess,
        setSnackbar,
        onClose,
    };

    return (
        <SnackbarContext.Provider value={contextData}>
            {children}
        </SnackbarContext.Provider>
    );
}
